import React, { memo, useMemo } from 'react';
import { RRule } from 'rrule';
import { Container, SingleDay } from './WeekDaysUI';

interface IProps {
  activeWeekDays: any;
  onSelectWeekDay: any;
}

export const dayOfWeek = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const weekDays = [
  RRule.SU,
  RRule.MO,
  RRule.TU,
  RRule.WE,
  RRule.TH,
  RRule.FR,
  RRule.SA,
];

export default memo(function WeekDays({
  activeWeekDays,
  onSelectWeekDay,
}: IProps) {
  const renderWeekDays = useMemo(
    () =>
      weekDays.map((weekDay: any) => {
        const dayName =
          weekDay !== RRule.TH && weekDay !== RRule.SA
            ? weekDay.toString().substring(0, 1)
            : weekDay.toString();

        const isActive = activeWeekDays.find(
          (activeWeekDay: any) => activeWeekDay.weekday === weekDay.weekday,
        );
        return (
          <SingleDay
            key={weekDay.toString()}
            onClick={() => onSelectWeekDay(weekDay)}
            size="default"
            $isActive={isActive}
          >
            {dayName}
          </SingleDay>
        );
      }),
    [activeWeekDays, onSelectWeekDay],
  );
  return <Container>{renderWeekDays}</Container>;
});
